<template>
  <CModal :show.sync="modalShow" title="Confirmar importación" color="dark" class="basic-modal-color" size="lg">
    <p class="mb-2"><strong>Tipo de importación:</strong> {{ importTypeLabel }}</p>

    <ul style="padding-left: 1rem; margin-top: 0.5rem;">
      <li>{{ summary.new_guests || 0 }} invitados nuevos.</li>
      <li>{{ summary.updated_guests || 0 }} invitados actualizados.</li>
      <li>{{ summary.warning_rows || 0 }} filas con advertencias.</li>
      <li>{{ summary.ignored_rows || 0 }} filas serán ignoradas.</li>
    </ul>

    <template #footer>
      <CButton color="secondary" @click="$emit('back')">Volver</CButton>
      <CButton color="dark" @click="$emit('confirm')">Confirmar</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'ImportConfirmationModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    importType: {
      type: String,
      default: 'initial_load'
    },
    summary: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    },
    importTypeLabel() {
      return this.importType === 'initial_load' ? 'Carga inicial' : 'Agregar o actualizar invitados'
    }
  }
}
</script>
